// extracted by mini-css-extract-plugin
export var closeButton = "_47-0";